import { Controller } from "@hotwired/stimulus"

// Client-side sign-up validation. HTML5 attributes on the form fields cover
// presence/length/format; this controller adds the one rule HTML5 can't
// express natively: password confirmation must match the password.
export default class extends Controller {
  static targets = ["password", "confirmation"]

  connect() {
    this.validateMatch()
  }

  validateMatch() {
    if (!this.hasPasswordTarget || !this.hasConfirmationTarget) return

    if (this.confirmationTarget.value !== this.passwordTarget.value) {
      this.confirmationTarget.setCustomValidity("Passwords do not match")
    } else {
      this.confirmationTarget.setCustomValidity("")
    }
  }
}
